import { useState } from "react";
import Section from "../components/Section";
import data from "../data/mythsQuiz.json";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

export default function Quiz() {
  const [i, setI] = useState(0);
  const [ans, setAns] = useState(null);
  const [score, setScore] = useState(0);
  const done = i >= data.length;

  function submit(val) {
    setAns(val);
    if (val === data[i].answer) setScore(s => s + 1);
  }
  function next() {
    setAns(null);
    setI(x => x + 1);
  }

  return (
    <Section
      eyebrow="Quiz"
      title="Myths vs Facts"
      subtitle="Take this quick quiz to bust common misconceptions."
    >
      <div className="max-w-2xl mx-auto">
        {/* Progress bar */}
        <div className="w-full h-2 rounded bg-slate-200 overflow-hidden mb-6">
          <div
            className="h-full bg-rose-600 transition-all duration-300"
            style={{ width: `${(Math.min(i, data.length) / data.length) * 100}%` }}
          />
        </div>

        {done ? (
          <div className="rounded-xl border p-8 bg-white shadow text-center">
            <p className="text-2xl font-bold text-slate-900">
              🎉 Your score: {score} / {data.length}
            </p>
            <p className="mt-2 text-slate-600">Great job learning the facts!</p>
            <a
              className="inline-block mt-6 px-6 py-3 rounded-lg bg-rose-600 text-white font-medium hover:bg-rose-700"
              href="/about"
            >
              Learn More
            </a>
          </div>
        ) : (
          <div className="rounded-xl border p-8 bg-white shadow">
            {/* Question */}
            <div className="flex items-center gap-2 mb-4">
              <span className="px-2 py-1 rounded-full bg-rose-100 text-rose-700 text-xs font-medium">
                Myth
              </span>
              <p className="text-lg text-slate-800 font-medium">
                {data[i].prompt}
              </p>
            </div>

            {/* Answer choices */}
            <div className="mt-6 grid grid-cols-2 gap-4">
              {["True", "False"].map((v) => (
                <button
                  key={v}
                  onClick={() => submit(v)}
                  className={`p-4 rounded-lg border text-lg font-medium transition-all
                    ${
                      ans === v
                        ? "bg-rose-600 text-white border-rose-600"
                        : "hover:border-rose-600 hover:bg-rose-50"
                    }`}
                >
                  {v}
                </button>
              ))}
            </div>

            {/* Feedback */}
            {ans && (
              <div className="mt-6 p-4 rounded-lg bg-slate-50 border text-slate-700">
                <div className="flex items-center gap-2 mb-2">
                  {ans === data[i].answer ? (
                    <FaCheckCircle className="text-green-600" />
                  ) : (
                    <FaTimesCircle className="text-rose-600" />
                  )}
                  <p className="font-semibold">
                    Correct Answer: {data[i].answer}
                  </p>
                </div>
                <p className="text-sm">{data[i].explanation}</p>
                <button
                  onClick={next}
                  className="mt-4 px-4 py-2 rounded bg-slate-900 text-white hover:bg-slate-800"
                >
                  Next →
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </Section>
  );
}
